@if (component) {
<div class="w-12 overflow-hidden"
     [ngClass]="component.ratio || 'ratio-2-1'">
    <href [link]="component.link"
          [hrefClass]="'fill'">
        <div class="z-1"
             [ngClass]="component.ratio && ((component.video_id && !component.video_hide) || component.background_image) ? 'overflow-hidden rf' : ''">
            <!-- image -->
            @if (component.background_image) {
            <df-image-wrapper class="fill">
                <img class="rf"
                     [dfImage]="component.background_image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="imageRatio"
                     fill>
            </df-image-wrapper>
            }

            @if (component.video_id && !component.video_hide) {
            @if (component.video_provider === 'youtube') {
            <youtube-player [video-id]="component.video_id"
                            [autoplay-in-viewport]="component.video_autoplay"
                            [background]="component.video_background">
                <!-- play icon -->
                <ng-template #playButton>
                    <button class="video-icon">
                        <i class="col-w icon-play"
                           aria-hidden="true"></i>
                    </button>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <button class="video-icon">
                        <i class="col-w icon-pause"
                           aria-hidden="true"></i>
                    </button>
                </ng-template>
            </youtube-player>
            }

            @if (component.video_provider === 'vimeo') {
            <local-vimeo-player [video-id]="component.video_id"
                                class="_vimeo"
                                [autoplay-in-viewport]="component.video_autoplay"
                                [background]="component.video_background">
                <!-- play icon -->
                <ng-template #playButton>
                    <button class="video-icon">
                        <i class="col-w icon-play"
                           aria-hidden="true"></i>
                    </button>
                </ng-template>

                <!-- pause icon -->
                <ng-template #pauseButton>
                    <button class="video-icon">
                        <i class="col-w icon-pause"
                           aria-hidden="true"></i>
                    </button>
                </ng-template>
            </local-vimeo-player>
            }
            }
        </div>
    </href>
    @if (component.blocks && component.blocks.length) {
    <div class="fill flex">
        <div class="flex"
             [ngClass]="component.width || 'w-12'">
            <div class="w-12 pos-relative">
                <!-- blocks -->
                @for (block of component.blocks; track $index) {
                <div class="pos-absolute z-2"
                     [ngClass]="['z-' + $index, block.style || '', (block.custom ? 'left-0' : '')]"
                     [style.top.%]="(block.top_position || 0)"
                     [style.left.%]="(block.custom ? 0 : block.left_position || 0)"
                     [style.transform]="'translate(-' + block.left_position + '%, -' + block.top_position + '%)'">
                    @if (block.custom) {
                    <icms-outlet class="pe-auto"
                                 [components]="block.components" />
                    } @else {
                    <!-- lines -->
                    @for (line of block.lines; track $index) {
                    @switch (line.type) {
                    @case ('text') {
                    <!-- text -->
                    <href [link]="line?.copyLink">
                        <span class="w-12 no-wrap"
                              [ngStyle]="{'color': line.color || ''}"
                              [ngClass]="[line.align||'', line.text_style|| 'h4', line.style||'']"
                              *iCms="'text' of line; tag: line.tag; content: 'html'"></span>
                    </href>
                    }
                    @case ('button') {
                    <div class="p-t-2 p-b-2"
                         [ngClass]="[
                                line.align || '',
                                line.form_size || '',
                                line.style || ''
                            ]">
                        <href [link]="line.button_link || component.link">
                            <span class="pe-auto"
                                  [ngClass]="(line.button_class||'')">
                                <span class="button__body"
                                      [ngStyle]="{'color': line.button_class === 'button-inline' ? '' + line.color : ''}"
                                      *iCms="'text' of line"></span>
                            </span>
                        </href>
                    </div>
                    }
                    @case ('countdown') {
                    <div class="w-12 no-wrap"
                         [ngStyle]="{'color': line.color || ''}"
                         [ngClass]="[line.align||'', line.text_style|| 'h4', line.style||'']">
                        <href [link]="line?.copyLink">
                            <countdown [date]="line.end_date"
                                       [shouldPad]="true">
                                <ng-template #countdownTemplate
                                             let-result>
                                    @if (result.score?.seconds) {
                                    @if (result.score?.days) { {{result.score?.days}}d }{{result.score?.hours}}h
                                    {{result.score?.minutes}}m {{result.score?.seconds}}s
                                    }
                                </ng-template>
                            </countdown>
                        </href>
                    </div>
                    }
                    }
                    }
                    }
                </div>
                }
            </div>
        </div>
    </div>
    }
</div>
}